import React, { useEffect, useRef } from "react";
import "./ContactUs.css";
import PageHeader from "./PageHeader";

const Contact = () => {
  const infoRef = useRef(null);
  const formRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-section");
          }
        });
      },
      { threshold: 0.2 }
    );

    if (infoRef.current) observer.observe(infoRef.current);
    if (formRef.current) observer.observe(formRef.current);
  }, []);

  // SEO & Structured Data
  useEffect(() => {
    // Title
    document.title =
      "Contact Us | Dr. Chavan Multispeciality Hospital, Indapur";

    // Meta description
    const metaDescription = document.createElement("meta");
    metaDescription.name = "description";
    metaDescription.content =
      "Contact Dr. Chavan Multispeciality Hospital in Indapur for appointments, enquiries, or any hospital information. Call, email, or send a message online.";
    document.head.appendChild(metaDescription);

    // Meta keywords
    const metaKeywords = document.createElement("meta");
    metaKeywords.name = "keywords";
    metaKeywords.content =
      "Contact Dr. Chavan Hospital, Indapur hospital phone, email, address, appointment enquiry";
    document.head.appendChild(metaKeywords);

    // Canonical
    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = "https://drchavanhospital.in/contact-us";
    document.head.appendChild(canonical);

    // JSON-LD Structured Data for MedicalOrganization
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MedicalOrganization",
      name: "Dr. Chavan Multispeciality Hospital",
      url: "https://drchavanhospital.in/",
      logo: "https://drchavanhospital.in/images/logo.webp",
      image: "https://drchavanhospital.in/images/pageheader.jpg",
      description:
        "Dr. Chavan Multispeciality Hospital provides advanced multispeciality healthcare in Indapur.",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Opposite to Irrigation Colony, Kalthan Road",
        addressLocality: "Indapur",
        addressRegion: "Maharashtra",
        postalCode: "413106",
        addressCountry: "IN",
      },
      telephone: ["+91 98765 43210", "+91 99887 77665"],
      email: "contact@hospital.com",
      sameAs: [
        "https://www.facebook.com/yourhospital",
        "https://www.instagram.com/yourhospital",
        "https://www.linkedin.com/company/yourhospital",
      ],
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(metaDescription);
      document.head.removeChild(metaKeywords);
      document.head.removeChild(canonical);
      document.head.removeChild(script);
    };
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();

    const name = e.target.name.value;
    const email = e.target.email.value;
    const phone = e.target.phone.value;
    const message = e.target.message.value;

    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\nPhone: ${phone}\n\nMessage:\n${message}`
    );

    window.location.href = `mailto:chavanhospitalindapur@gmail.com?subject=New Enquiry from Website&body=${body}`;
  };

  return (
    <>
      {/* PAGE HEADER */}
      <PageHeader
        title="Get In Touch"
        breadcrumbs={["Home", "Contact Us"]}
        background="/images/pg.webp"
      />

      {/* MAIN CONTACT SECTION */}
      <div className="contact-section">
        {/* LEFT — CONTACT INFORMATION */}
        <div ref={infoRef} className="contact-info hidden-section">
          <h1>Contact Us</h1>

          <h3>Reach Out Anytime</h3>
          <p>
            We are here to help you with appointments, enquiries, or any
            information you need. Feel free to call or send a message.
          </p>

          <div className="contact-divider"></div>

          <h3>Address</h3>
          <p>
            Dr. Chavan Multispeciality Hospital <br />
            Opposite to Irrigation Colony, Kalthan Road <br />
            Indapur, Dist - Pune, Maharashtra 413106
          </p>

          <div className="contact-divider"></div>

          <h3>Phone</h3>
          <p>
            +91 75885 06558 <br />
            {/* +91 99887 77665 */}
          </p>

          <div className="contact-divider"></div>

          <h3>Email</h3>
          <p>chavanhospitalindapur@gmail.com</p>
        </div>

        {/* RIGHT — CONTACT FORM */}
        <div ref={formRef} className="contact-form-wrapper hidden-section">
          <h2>Send Us a Message</h2>

          <form className="contact-form" onSubmit={handleSubmit}>
            <input name="name" type="text" placeholder="Full Name" required />
            <input
              name="email"
              type="email"
              placeholder="Email Address"
              required
            />
            <input
              name="phone"
              type="text"
              placeholder="Phone Number"
              required
            />
            <textarea name="message" placeholder="Your Message" required />
            <button type="submit" className="contact-btn">
              Submit Enquiry
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Contact;
